// Used for k-transfer and markup
export const PRICE_LIST_ND = 'n.d.';
// Used for prices if priceType and price are null
export const PRICE_LIST_NA = 'na';
// End validity date of the revision in force with no end (APPLYMESD-2794)
export const PRICE_LIST_OPEN_END_VALIDITY_DATE = '9999-12-31';

// APPLYMESD-2794
export const PRICE_LIST_DEACTIVATION_RESOURCES = {
  DEACTIVATE: 521020, // "Disattiva" / "Deactivate"
  DEACTIVATE_FROM: 521021, // "Disattiva a partire da" / "Deactivate from"
  WARRANTY_TEXT: 521022, // testo del dialog del tab Extended Warranties
  MARKUP_TEXT: 521023, // testo del dialog del tab Markup
  WARRANTY_MARKUP_TEXT: 521024, // testo del dialog del tab Extended Warranties Markup
  DEACTIVATED_TOAST: 521025, // "Disattivazione salvata" / "Deactivation saved"
  ZERO_VALUE_NOTE: 521026, // nota sul significato dello 0 e della cella vuota
};

export const PRICE_LIST_PUBLISH_LEVEL_COLOR_MAP: { [key: string]: string } = {
  L1: 'rgb(197,217,241)',
  L2: 'rgb(255,192,0)',
  T1: 'rgb(196,215,155)',
  L5: 'rgb(217,217,217)',
  L6: 'rgb(255,204,255)',
  L7: 'rgb(255,255,255)',
  T2: 'rgb(146,208,80)',
};
